const BACKEND_URL = process.env.REACT_APP_API_URL;
const API_BASE = `${BACKEND_URL}/withdrawal`;

// -------------- Helper for GET --------------
async function getJSON(url, token) {
  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res.json();
}

// -------------- GET Eligible Withdrawal Amount --------------
export const getEligibleAmount = (token) =>
  getJSON(`${API_BASE}/eligible-amount`, token);

// -------------- GET Withdrawal Status (Flutter uses this!) --------------
export const getWithdrawalStatus = (token) =>
  getJSON(`${API_BASE}/status`, token);

// -------------- GET Withdrawal History --------------
export const getWithdrawalHistory = async (token) => {
  const json = await getJSON(`${API_BASE}/history`, token);
  return json.history || []; // Flutter expects array, not object
};

// -------------- GET Bank Details Status (Missing in your code!) --------------
export const getBankDetails = (token) =>
  getJSON(`${API_BASE}/bank-details`, token);

// -------------- POST Request Withdrawal --------------
export const requestWithdrawal = async (token) => {
  const res = await fetch(`${API_BASE}/request`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res.json();
};

// -------------- POST Save Bank Details --------------
export const saveBankDetails = async (data, token) => {
  const res = await fetch(`${API_BASE}/bank-details`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return res.json();
};
export const requestAgentWithdrawal = async (token) => {
  const res = await fetch(`${API_BASE}/request/agent`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res.json();
};
export const getAgentEligibleAmount = (token) =>
  getJSON(`${API_BASE}/eligible-amount/agent`, token);

export const getAgentWithdrawalHistory = async (token) => {
  const json = await getJSON(`${API_BASE}/agent/history`, token);
  return json.history || [];
};
